<template>
  <span>
    <span v-if="fake && !fakeTip" class="round-shape light-color">
      <span class="initials-empty" >{{ fake }}</span>
    </span>
    <span v-if="fake && fakeTip" class="round-shape light-color"  v-b-tooltip.hover.bottom :title="''+fakeTip">
      <span class="initials-empty" >{{ fake }}</span>
    </span>
    <span v-if="user && !noTip" class="round-shape" v-b-tooltip.hover.bottom :title="user.prenom+' '+user.nom">
      <span class="initials" >{{ user.initials }}</span>
      <img class="image" :src="url+'/avatars/'+user.email+'.jpg'" onerror="this.style.display='none'"/>
    </span>
    <span v-if="user && noTip" class="round-shape">
      <span class="initials" >{{ user.initials }}</span>
      <img class="image" :src="url+'/avatars/'+user.email+'.jpg'" onerror="this.style.display='none'"/>
    </span>
  </span>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Avatar',
  props: ['user', 'fake', 'fakeTip', 'noTip'],
  data: function(){
    return {
      url: Vue.$backend.getBackendUrl(),
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.round-shape{    
  position: relative;
  
  background-color: lightgrey;
  border-radius: 50%;
  padding: 3px;
  display: inline-block;
  
  color: black;
  height: 28px;
  width: 28px;
  line-height: 28px;
  text-align: center;
}

.light-color{
  background-color: whitesmoke;
}

.initials{
  position: absolute;
  top: 0px;
  left: 5px;
  
  font-size: 12px;
  font-weight: 700;
}

.initials-empty{
  position: absolute;
  top: -2px;
  left: 8px;
  font-size: 18px;
  font-weight: 700;
}

.image{
  position: absolute;
  top: 0;
  left: 0;
  
  border-radius: 50%;
  width: 30px;
  height: 30px;
}

</style>
